import { render } from "./DaughtersGeneralTable.vue?vue&type=template&id=2ec9a1fd&ts=true"
import script from "./DaughtersGeneralTable.vue?vue&type=script&lang=ts"
export * from "./DaughtersGeneralTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__